import { get } from "../../utils/objectHelpers";

<if(input)>
    $ {
        const title = get(input, "title", {});
        const { protocol, hostname } = new URL(get(input, "action.URL", ""));
    }

    <div class="str-survey">
        <a href="#" id="str-survey">
            <str-textual-display ...title />
            <span>
                <ebay-thumbs-up-icon />
                <ebay-thumbs-down-icon />
            </span>
        </a>
    </div>
    <script type="text/javascript" src=`${protocol}//${hostname}/srv/app/v2/plugin/survey-modal.js`></script>
</if>
